import { Popover, PopoverProps } from '@mui/material';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLogout } from 'components/auth/hooks/useLogout';
import AboutV1Icon from 'components/system/Icons/AboutV1Icon';
import AccountV1Icon from 'components/system/Icons/AccountV1Icon';
import LogoutV1Icon from 'components/system/Icons/LogoutV1Icon';
import PopoverItem from './PopoverItem';
import { StyledList } from './status.styles';

interface IStatusMenu extends Pick<PopoverProps, 'anchorEl' | 'onClose'> {
  isOpen: boolean;
}

const StatusMenu: FC<IStatusMenu> = ({ anchorEl, isOpen, onClose }) => {
  const navigate = useNavigate();

  const { logout } = useLogout();

  const createOnClickHandler = (proceedMethod: () => void) => {
    return (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();
      onClose?.(e, 'backdropClick');
      proceedMethod();
    };
  };

  return (
    <Popover
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: 'transparent',
          },
        },
      }}
    >
      <StyledList>
        <PopoverItem
          to="/app/my-account"
          onClick={createOnClickHandler(() => {
            navigate('/app/my-account');
          })}
          icon={<AccountV1Icon />}
          text="My Account"
        />
        <PopoverItem
          to="/app/about"
          text="About"
          icon={<AboutV1Icon />}
          onClick={createOnClickHandler(() => {
            navigate('/app/about');
          })}
        />
        <PopoverItem
          to="/"
          onClick={createOnClickHandler(logout)}
          icon={<LogoutV1Icon />}
          text="Log Out"
        />
      </StyledList>
    </Popover>
  );
};

export default StatusMenu;
